import { Home, UtensilsCrossed, Star, Users, LayoutGrid } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface BottomNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  onCreateClick?: () => void;
  className?: string;
}

const tabs = [
  { id: 'feed', icon: Home, label: 'Home' },
  { id: 'menus', icon: UtensilsCrossed, label: 'Restaurants' },
  { id: 'create', icon: Star, label: 'Review' },
  { id: 'friends', icon: Users, label: 'Friends' },
  { id: 'myeatzy', icon: LayoutGrid, label: 'My Eatzy' }
];

export default function BottomNavigation({ activeTab, onTabChange, onCreateClick, className }: BottomNavigationProps) {
  const handleTabClick = (tabId: string) => {
    console.log(`Navigating to ${tabId}`);
    if (tabId === 'create' && onCreateClick) {
      onCreateClick();
    } else {
      onTabChange(tabId);
    }
  };

  return (
    <nav className={cn("fixed bottom-0 left-0 right-0 bg-card border-t border-border safe-area-padding-bottom z-50", className)}>
      <div className="flex items-center h-16 px-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const isCreate = tab.id === 'create';

          if (isCreate) {
            return (
              <Button
                key={tab.id}
                variant="default"
                onClick={() => handleTabClick(tab.id)}
                className="shrink-0 rounded-full px-4 h-10 bg-primary flex items-center gap-1.5"
                data-testid={`nav-${tab.id}`}
              >
                <Star className="w-4 h-4 fill-current" />
                <span className="text-sm font-semibold">Review</span>
              </Button>
            );
          }

          return (
            <Button
              key={tab.id}
              variant="ghost"
              onClick={() => handleTabClick(tab.id)}
              className={cn(
                "flex-1 min-w-0 flex flex-col items-center justify-center gap-1 px-1 py-2 h-auto min-h-12",
                isActive ? "text-primary" : "text-muted-foreground"
              )}
              data-testid={`nav-${tab.id}`}
            >
              <span className="relative">
                <Icon className={cn("w-6 h-6 shrink-0", isActive && "fill-current")} />
              </span>
              <span className="text-xs font-medium truncate max-w-full">{tab.label}</span>
            </Button>
          );
        })}
      </div>
    </nav>
  );
}
